import { SvgIcon, SvgIconProps } from '@mui/material';
import './ccf-delete-voice-mail-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfDeleteVoiceMailIconProps extends SvgIconProps  {}

/**
 * Component used to delete voicemail Icon
 * @param props - CcfDeleteVoiceMailIconProps
 * @example
 * @returns
 */
export function CcfDeleteVoiceMailIcon(props: CcfDeleteVoiceMailIconProps) {
  return (
    <SvgIcon
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      {...props}
    >
      <path d="M22.1786 1.43751H16.0179L15.5353 0.597469C15.433 0.417877 15.2756 0.266809 15.0806 0.161259C14.8856 0.0557084 14.6608 -0.000136022 14.4315 7.87602e-06H8.56339C8.33461 -0.00076166 8.11022 0.0548745 7.9159 0.160542C7.72159 0.26621 7.56523 0.417635 7.46473 0.597469L6.98214 1.43751H0.821429C0.603572 1.43751 0.394639 1.51323 0.240591 1.64802C0.0865431 1.78282 0 1.96563 0 2.15626L0 3.59376C0 3.78438 0.0865431 3.9672 0.240591 4.10199C0.394639 4.23678 0.603572 4.31251 0.821429 4.31251H22.1786C22.3964 4.31251 22.6054 4.23678 22.7594 4.10199C22.9135 3.9672 23 3.78438 23 3.59376V2.15626C23 1.96563 22.9135 1.78282 22.7594 1.64802C22.6054 1.51323 22.3964 1.43751 22.1786 1.43751ZM2.73125 20.9785C2.77043 21.5259 3.04656 22.0397 3.50342 22.4153C3.96029 22.7908 4.56355 22.9999 5.1904 23H17.8096C18.4365 22.9999 19.0397 22.7908 19.4966 22.4153C19.9534 22.0397 20.2296 21.5259 20.2687 20.9785L21.3571 5.75001H1.64286L2.73125 20.9785Z" />
    </SvgIcon>
  );
}

export default CcfDeleteVoiceMailIcon;
